export const buildPhoneNumber = ({
  countryCode,
  code,
  number,
}: {
  countryCode?: number | string | null
  code?: number | string | null
  number?: number | string | null
}) => {
  if (!number) return ""
  countryCode = code || countryCode
  if (!countryCode || !number) {
    return ""
  }

  let prefix = "+"
  if (countryCode.toString().includes("+")) {
    prefix = ""
  }
  return `${prefix}${countryCode}${number}`
}
